import type { EdgeInsets } from "@-/com.npmjs.react-native-safe-area-context";

/** The horizontal screen edge that holds the notch / Dynamic Island in landscape. */
export type SensorHousingEdge = "left" | "right";

/**
 * iOS reports the same left and right inset in landscape even though only one edge holds the
 * sensor housing. Zero the opposite edge so content reaches the unobstructed side of the display.
 */
export function getDeviceEdgeSafeAreaInsets(
  insets: EdgeInsets,
  sensorHousingEdge: SensorHousingEdge | null,
): EdgeInsets {
  if (sensorHousingEdge === "right" && insets.left > 0) {
    return { ...insets, left: 0 };
  }
  if (sensorHousingEdge === "left" && insets.right > 0) {
    return { ...insets, right: 0 };
  }
  return insets;
}
